import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=d0a88360&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/index.css?vue&type=style&index=0&id=d0a88360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a88360",
  null
  
)

export default component.exports